import { X } from 'lucide-react';
import React from 'react';
import styles from './SegmentVisualBuilder.module.css';

interface ClauseDescriptionHeadlineProps {
  description: string;
  onChange: (description: string | undefined) => void;
  variant: 'group' | 'row';
  disabled?: boolean;
}

const PLACEHOLDER = 'Describe this clause (optional)';

export const ClauseDescriptionHeadline: React.FC<ClauseDescriptionHeadlineProps> = ({
  description,
  onChange,
  variant,
  disabled = false,
}) => {
  const inputClass = variant === 'group' ? styles.descriptionInputGroup : styles.descriptionInputRow;

  const handleBlur = () => {
    if (description === '') onChange(undefined);
  };

  return (
    <div className={styles.descriptionEdit}>
      <input
        type="text"
        className={inputClass}
        value={description}
        onChange={e => onChange(e.target.value)}
        onBlur={handleBlur}
        placeholder={PLACEHOLDER}
        disabled={disabled}
        autoFocus={description === ''}
        aria-label="Clause description"
      />
      <button
        type="button"
        className={styles.descriptionClearBtn}
        onClick={() => onChange(undefined)}
        disabled={disabled}
        aria-label="Remove description">
        <X size={14} />
      </button>
    </div>
  );
};
